import { useTranslation as useTranslate } from 'react-i18next';

import en from '../../components/i18nProvider/en';

export type Iprefix = keyof typeof en;
export type IcommonKey = keyof typeof en.common;
export type IenumKey = keyof typeof en.enumConstants;
export type IcountryCodeKey = keyof typeof en.countryCodes;

export default function useTranslation(prefix?: any) {
  // const translate = useTranslate();
  const { t: i18nTranslate, i18n } = useTranslate();

  const currentLanguage = i18n.language;

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  const getTranslateKey = (key: string) => {
    let namespace = prefix;
    const [ns, ...rest] = key.split('.');

    if (rest.length > 0) {
      namespace = ns as any;
      key = rest.join('.');
    }

    return { namespace, finalKey: key };
  };

  const displayExistEnumOnly = (key: string, params = {}) => {
    const notAssignedOrNotFoundKey = key ? `{{${key}}}` : '';

    return Object.keys(en.enumConstants).includes(key)
      ? i18nTranslate(`${key}`, { ns: 'enumConstants', ...params })
      : notAssignedOrNotFoundKey;
  };

  const genericTranslate = (key: string, params = {}) => {
    return prefix === 'enumConstants'
      ? displayExistEnumOnly(key, params)
      : i18nTranslate(key, { ns: prefix as string, ...params });
  };

  const translate = (key: string, params?: {}) => {
    const { namespace, finalKey } = getTranslateKey(key);

    return i18nTranslate(finalKey, { ns: namespace, ...params });
  };

  const tc = (key: IcommonKey, params = {}) => i18nTranslate(key, { ns: 'common', ...params });

  const t = (key: string, params = {}) => genericTranslate(key, params);

  const te = (key: IenumKey, params = {}) => displayExistEnumOnly(key, params);

  const tb = (expectedBol: unknown) => {
    if (expectedBol === true) {
      return te('yes');
    }
    if (expectedBol === false) {
      return te('no');
    }
    return '';
  };

  const tcc = (countryCode: string) =>
    en.countryCodes.find(({ isoCode3 }) => countryCode === isoCode3)?.country || '';

  return { translate, i18n, currentLanguage, changeLanguage, t, tc, te, tcc, tb };
}
